module.exports = __webpack_public_path__ + "static/media/3.667a39d5.jpg";